import { MatDialog } from "@angular/material/dialog";
import { Component, ElementRef, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AccountService } from "src/app/services/account.service";
import { GridsterService } from "src/app/services/gridster.service";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  darkTheme: boolean;
  showNewsBar: any;
  showQuickButton: any;
  userProfile: any;
  fontSize: any;

  zoomValues=[
    "80",
    "100",
    "120",
    "140",
    "150"
  ]
  
  constructor(
    private dialog: MatDialog,
    private acc: AccountService,
    private router: Router,
    private gridsterService: GridsterService,
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.fontSize = localStorage.getItem("fontsize")
    ? localStorage.getItem("fontsize")
    : "100";
    if (localStorage.getItem("userProfile") != null) {
      this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    }
    this.showNewsBar = this.acc.Ticker;
    this.showQuickButton = this.acc.quickButton;
    this.darkTheme = localStorage.getItem("darktheme") == "dark" ? true : false;
  }

  saveSettings() {
    localStorage.setItem("showTicker", JSON.stringify(this.showNewsBar));
    localStorage.setItem("showQuickButton", JSON.stringify(this.showQuickButton));
    localStorage.setItem("fontsize", this.fontSize);
    localStorage.setItem("darktheme", this.darkTheme ? "dark" : "light");
    document.body.setAttribute(
      "data-theme",
      this.darkTheme ? "dark" : "light"
    );
    this.acc.setTicker(this.showNewsBar);
    this.acc.setQuickButton(this.showQuickButton);
    this.dialog.closeAll();
    let zoomPercent = `${this.fontSize}%`
    this.elementRef.nativeElement.ownerDocument
    .body.style.zoom = zoomPercent;
    window.location.reload();
  }

  navigateChangePw() {
    this.router.navigateByUrl("/changePassword");
    this.dialog.closeAll();
  }

  switchTheme() {
    this.gridsterService.switchTheme();
  }
}
